/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import DatagridRow from './Datagrid/DatagridRow';

var useRowRenderer = function useRowRenderer(hooks) {
  var useInstance = function useInstance(instance) {
    var rows = instance.rows;

    var addRowRenderer = function addRowRenderer(row) {
      return Object.assign(row, {
        RowRenderer: DatagridRow,
        subRows: (row.subRows || []).map(addRowRenderer)
      });
    };

    var rowsWithRenderer = rows.map(addRowRenderer);
    Object.assign(instance, {
      rows: rowsWithRenderer
    });
  };

  hooks.useInstance.push(useInstance);
};

export default useRowRenderer;